module.exports = __webpack_public_path__ + "e5e379266e7bc3df976683bc451af0ba.png";